"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var headerCellClassName = function (sort, field, locked) {
    var result = "" + (locked ? 'k-grid-header-sticky' : '');
    if (sort.some(function (descriptor) { return descriptor.field === field; })) {
        result += ' k-sorted';
    }
    return result;
};
/**
 * @hidden
 */
exports.FilterRow = function (props) {
    var columns = props.columns, filter = props.filter, filterChange = props.filterChange, _a = props.sort, sort = _a === void 0 ? [] : _a;
    return (React.createElement("tr", { className: "k-filter-row" }, columns.map(function (column, index) {
        var style = (column.locked !== undefined) ? {
            left: column.left,
            right: column.right,
            borderRightWidth: column.rightBorder ? '1px' : ''
        } : {};
        return (React.createElement("th", { style: style, key: index, className: headerCellClassName(sort, column.field, column.locked) }, column.filter && (React.createElement(column.filter, { field: column.field, filter: filter, onFilterChange: filterChange }))));
    })));
};
//# sourceMappingURL=FilterRow.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/header/FilterRow.js
// module id = 6496
// module chunks = 0